let showLoader = () => {};
let hideLoader = () => {};

export function setLoaderControl({ showLoader: show, hideLoader: hide }) {
  showLoader = show;
  hideLoader = hide;
}

export function getLoaderControl() {
  return { showLoader, hideLoader };
}